<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">Crawl Result Management</span>
    </div>
    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
      <Spinner />
    </div>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable
                  :pagination="pagin"
                  :columns="DomainCrawlResultManagementColumn"
                  :dataSource="data"
                  :tableSize="tableSize">
            <template slot="start" slot-scope="{ record }">
              <p class="time-text">
                <time>
                  {{ record.start | dateString }}
                </time>
              </p>
              <p class="time-text">
                <time>
                  {{ record.start | timeString }}
                </time>
              </p>
            </template>
            <template slot="end" slot-scope="{ record }">
              <p class="time-text">
                <time>
                  {{ record.end | dateString }}
                </time>
              </p>
              <p class="time-text">
                <time>
                  {{ record.end | timeString }}
                </time>
              </p>
            </template>
            <template slot="operation" slot-scope="{ record }">
              <a-dropdown placement="topLeft">
                <a-icon class="operation" type="ellipsis" />
                <a-menu slot="overlay" class="operation-menu">
                  <a-menu-item>
                    <router-link :to="'/batch-jobs/detail-crawl/CR' + record.id">
                      <img class="mr-2" src="@assets/icon/report.svg" />
                      Crawl Details
                    </router-link>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer">
      <PaginationBar :total="pagin.total" @change="paginChange" />
    </div>
  </div>
</template>

<script>

  import { DomainCrawlResultManagementColumn } from "../columnsTable/DomainCrawlResultManagementColumn";
  import { PAGE_OPTIONS } from '@constants/pageOptions';
  import DomainService from "../services/Domain.service";

  export default {
    name: 'DomainCrawlResultManagement',
    data() {
      return {
        DomainCrawlResultManagementColumn,
        PAGE_OPTIONS,
        data: [],
        filterData: [],
        contactGroups: [],
        filterParams: {
          search: ''
        },
        pagin: {
          current: 1,
          pageSize: 5,
          total: 0
        },
        isLoading: true,
        tableSize: {
          height: '',
          width: ''
        },
        domain: {
          id: +this.$route.params.id,
        },
      };
    },
    mounted() {
      this.fetchList();
    },
    methods: {
      elSizeChange() {},
      async fetchList() {
        try {
          const responseData = await DomainService.fetchDomainCrawlsById(this.domain.id);

          this.data = (responseData || []).map((item, index) => ({
            ...item,
            index: index + 1,
          }));

          this.pagin.total = this.data.length;
        } catch (error) {
          this.$showErrorMessage('HTTP error received from web server!');
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .time-text {
    margin-bottom: 0;
  }
</style>
